module.exports = __webpack_public_path__ + "static/img/news-d1.d9b350d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-d1.png
// module id = Lgkn
// module chunks = 1